import React from "react";
import { AllVisitsStyle } from "./AllVisitsStyle";
import { useEffect, useState } from "react";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import Button from "../Button/Button";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
import { FiEdit } from "react-icons/fi";
import { EditActionModal } from "../Dialog/EditActionModal";
import { Link } from "react-router-dom";
import { ChangeActivityDateModal } from "../Dialog/ChangeActivityDateModal";
import { useRecoilState } from "recoil";
import { crmActionCheckListAtom } from "../../shared/crm-action-checklist";
import { DeleteActivityModal } from "../Dialog/DeleteActivitiyModal";
import { useGetAllActivities } from "../../hooks/useCrm";
const initmodalvalue = {
  editaction: false,
  changeactivitydate: false,
  deleteactivity: false,
};
const AllVisits = () => {
  const [show, setShow] = useState(initmodalvalue);
  const [checked, setChecked] = useRecoilState(crmActionCheckListAtom);
  const [Search, setSearch] = useState("");
  const [editActionData, setEditActionData] = useState();
  const headerTitle = [
    "ردیف",
    "انتخاب",
    "نام و نام خانوادگی ",
    "عنوان فعالیت",
    "مسئول",
    "تاریخ فعالیت",
    "عملیات",
  ];
  const { data, isLoading } = useGetAllActivities();
  const length = data?.data?.activity_crms?.filter((item) => {
    if (
      item.SubjectActivityCrm === "مراجعه به انبار" ||
      item.SubjectActivityCrm === "شارژ محصول" ||
      item.SubjectActivityCrm === "ویزیت حضوری" ||
      item.SubjectActivityCrm === "پیگیری دوره ای تماس"
    ) {
      return item;
    }
  });
  var i = 0;
  const items = data?.data?.activity_crms
    .filter((user) => {
      if (Search === "") {
        return user;
      } else if ((user.FirstName + " " + user.LastName).includes(Search)) {
        return user;
      } else if (user.LastName?.includes(Search)) {
        return user;
      } else if (user.SubjectActivityCrm?.includes(Search)) {
        return user;
      }
    })
    .map((item, index) => {
      return item.SubjectActivityCrm === "مراجعه به انبار" ||
        item.SubjectActivityCrm === "شارژ محصول" ||
        item.SubjectActivityCrm === "ویزیت حضوری" ||
        item.SubjectActivityCrm === "پیگیری دوره ای تماس" ? (
        <tr key={item.IdActivityCrm}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {(i += 1)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <input
                type="checkbox"
                checked={checked.length ? null : false}
                value={item.IdActivityCrm}
                onChange={() => {
                  setChecked((prevState) => {
                    if (prevState.includes(item.IdActivityCrm)) {
                      return prevState.filter(
                        (st) => st !== item.IdActivityCrm
                      );
                    } else {
                      return [...prevState, item.IdActivityCrm];
                    }
                  });
                }}
              />
            </span>
          </td>
          <td>
            <Link
              to={`/dashboard/crm/customer-file/${item.IdS0alesOpportunities}`}
            >
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {(item.FirstName ? item.FirstName : "") +
                  " " +
                  (item.LastName ? item.LastName : "")}
              </span>
            </Link>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.SubjectActivityCrm}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {data?.data?.user.map((user) =>
                user.IdActivityCrm === item.IdActivityCrm
                  ? (user.FirstName ? user.FirstName : "") +
                    " " +
                    (user.LastName ? user.LastName : "")
                  : null
              )}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(item.DateReferenceActivityCrm)}
            </span>
          </td>
          <td>
            <div className="d-flex">
              <Button
                bgColor="#0d6efd"
                small="fit-content"
                onclick={() => {
                  setShow({ ...show, editaction: true });
                  setEditActionData(item);
                }}
              >
                <FiEdit color="#fff" />
              </Button>
            </div>
          </td>
        </tr>
      ) : null;
    });

  return (
    <AllVisitsStyle>
      {isLoading ? (
        <Loading />
      ) : (
        <Table
          headerTitle={headerTitle}
          title={`کل فعالیت ها ${length?.length}`}
          items={items}
          setSearch={setSearch}
          dateFilter={
            <div className="col-lg-8 mt-4">
              <Button
                small="fit-content"
                bgColor="#009ef7"
                color="#fff"
                className="mx-2 mb-2"
                size="12px"
                onclick={() => {
                  setShow({ ...show, changeactivitydate: true });
                }}
              >
                تغییر تاریخ
              </Button>
              <Button
                small="fit-content"
                bgColor="#f1416c"
                color="#fff"
                className="mb-2"
                size="12px"
                onclick={() => {
                  setShow({ ...show, deleteactivity: true });
                }}
              >
                حذف
              </Button>
            </div>
          }
        />
      )}
      <EditActionModal
        show={show.editaction}
        handleClose={() => setShow({ ...show, editaction: false })}
        editActionData={editActionData}
      />
      <ChangeActivityDateModal
        show={show.changeactivitydate}
        handleClose={() => setShow({ ...show, changeactivitydate: false })}
        dates={checked.toString()}
      />
      <DeleteActivityModal
        show={show.deleteactivity}
        handleClose={() => setShow({ ...show, deleteactivity: false })}
        dates={checked.toString()}
      />
    </AllVisitsStyle>
  );
};

export default AllVisits;
